import React, {Component} from 'react';

import { connect } from "react-redux";

import {IDropdownOption} from "office-ui-fabric-react";
import { IRootState } from "../store";
import School, { SchoolWithAccessLevel } from "../models/School";
import DispatchProps from "../utils/DispatchProps";
import * as H from "history";
import { friendlySchoolName } from "../utils/Utils";
import { AccountInfo } from '@azure/msal-browser';
import { ComboBox } from 'office-ui-fabric-react/lib-commonjs';
import SchoolLicenseBanner from './SchoolLicenseBanner';

interface CDBSchoolSelectorProps {
    
    tenantId: string;
    schoolCode?: string;
    
    schoolsCanAccess?: SchoolWithAccessLevel[],
    user?: AccountInfo,
    userIsCdbEmployee: boolean,
    userIsTenantManager: boolean,
    selectedOptionOverride?: undefined | "manage-tenant";
    history: H.History
}

interface CDBSchoolSelectorState {
}

class CDBSchoolSelector extends Component<CDBSchoolSelectorProps & DispatchProps, CDBSchoolSelectorState> {

    static displayName = CDBSchoolSelector.name;

    constructor(props: CDBSchoolSelectorProps & DispatchProps) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {
    }
    
    async componentDidUpdate(prevProps: CDBSchoolSelectorProps, prevState: CDBSchoolSelectorState): Promise<void> {
    }
    
    private _onSchoolSelected = async (event: any, o?: IDropdownOption) => {
        if (o) {
            
            if(o.key === "manage-tenant")
            {
                this.props.history.push(`/manage-tenant/${this.props.user!.tenantId}`);
            }
            else
            {
                const school = o.data as School;
                this.props.history.push(`/manage/${school.tenantId}/${school.schoolCode}`);
            }
        }
    };
    
    calculateOptions(): IDropdownOption[]
    {
        let options: IDropdownOption[] = [];
        if (this.props.schoolsCanAccess)
        {
            options = this.props.schoolsCanAccess.map((schoolWithAccessLevel) => {
                return {
                    key: schoolWithAccessLevel.school.schoolCode!,
                    text: friendlySchoolName(schoolWithAccessLevel.school),
                    data: schoolWithAccessLevel.school
                } as IDropdownOption;
            });
        }


        if (this.props.userIsTenantManager)
        {
            options.splice(0, 0, {
                key: "manage-tenant",
                text: "All Schools",
                data: {}
            });
        }
        
        return options;
        
    }
    
    renderSelector(tenantId: string,schoolCode: string | undefined,selectedKeyOverride: undefined | "manage-tenant"): JSX.Element
    {
        const options = this.calculateOptions();
        if(options.length === 0)
        {
            return (<div className={"cdb-admin-school-selector"}/>);
        }

        let selectedKey: string | null = null;
        let selectedSchool: School | undefined = undefined;

        if(this.props.selectedOptionOverride)
        {
            selectedKey = this.props.selectedOptionOverride;
        }
        else if(schoolCode)
        {
            selectedKey = schoolCode;
            selectedSchool = this.props.schoolsCanAccess?.filter(sca => sca.school.tenantId === tenantId && sca.school.schoolCode == schoolCode)[0].school;
        }
        
        
        return (
            <div className={"cdb-admin-school-selector"}>
                <div className="cdb-admin-content p-left-1rem">
                    <ComboBox
                        label=""
                        selectedKey={selectedKeyOverride ?? selectedKey}
                        onChange={this._onSchoolSelected}
                        placeholder="Select School"
                        options={options}
                        className={"cdb-admin-school-selector-options"}
                        autoComplete={'on'}
                        allowFreeform={false}
                        autoCapitalize={'off'}
                    />
                </div>
                <SchoolLicenseBanner school={selectedSchool}/>
            </div>
        );
    }

    render() {
        if (!this.props.user) {
            return null;
        }

        if (this.props.userIsCdbEmployee) {
            return null;
        }

        return this.renderSelector(this.props.tenantId, this.props.schoolCode, this.props.selectedOptionOverride);
    }
}

export default connect(
    (state: IRootState, ownProps: { tenantId: string, schoolCode?: string,selectedOptionOverride?: undefined | "manage-tenant" }): CDBSchoolSelectorProps => {
        return {
            tenantId: ownProps.tenantId,
            schoolCode: ownProps.schoolCode,
            history: state.history,
            schoolsCanAccess: state.schools.schoolsCanAccess,
            userIsTenantManager: state.schools.userIsTenantManager,
            selectedOptionOverride: ownProps.selectedOptionOverride,
            user: state.auth.user,
            userIsCdbEmployee: state.auth.userIsCdbEmployee
        };
    }
)(CDBSchoolSelector);